import { localStorageInstance } from '@gem/modules/storage';
import { parseJSON } from '@gem/utils';

import { ChatBackgroundPattern, ChatBackgroundType } from 'APP/constants/appearance';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';

const KEY_NAME = 'chatBackgroundsByEntity';

type ChatBackgroundsMap = Record<string, TChatBackground>;

const getKeyWithUserId = (userId: string | null): string => {
  return userId ? `${KEY_NAME}_${userId}` : KEY_NAME;
};

/* Миграция старых паттернов фонов в дефолтный */
function mapOldPatternToNewPattern(
  chatBackgrounds: object,
  userId: string | null = null
): ChatBackgroundsMap {
  const updated = Object.entries(chatBackgrounds).reduce((acc, [key, background]) => {
    if (typeof background === 'string') {
      const pattern = ChatBackgroundPattern.Brand;
      const chatBackground: TChatBackground = {
        type: ChatBackgroundType.Pattern,
        background: pattern,
      };
      acc[key] = chatBackground;
    } else {
      acc[key] = background;
    }
    return acc;
  }, {} as ChatBackgroundsMap);

  localStorageInstance.setItem(getKeyWithUserId(userId), JSON.stringify(updated));

  return updated;
}

export const set = (
  entityId: string,
  chatBackground: TChatBackground,
  userId: string | null = null
): void => {
  const current = get(userId);
  const updated: ChatBackgroundsMap = { ...current, [entityId]: chatBackground };

  localStorageInstance.setItem(getKeyWithUserId(userId), JSON.stringify(updated));
};

export const get = (userId: string | null = null): ChatBackgroundsMap => {
  const value = localStorageInstance.getItem(getKeyWithUserId(userId));

  if (!value) {
    return {};
  }

  const chatBackgrounds = parseJSON(value);

  if (chatBackgrounds) {
    return mapOldPatternToNewPattern(chatBackgrounds, userId);
  }
  return {};
};

export const getByEntityId = (
  entityId: string,
  userId: string | null = null
): TChatBackground | null => {
  const map = get(userId);
  return map[entityId] || null;
};

export const remove = (entityId: string, userId: string | null = null): void => {
  const current = get(userId);
  const rest = { ...current };
  delete rest[entityId];
  localStorageInstance.setItem(getKeyWithUserId(userId), JSON.stringify(rest));
};

export const removeAll = (userId: string | null = null): void => {
  localStorageInstance.removeItem(getKeyWithUserId(userId));
};
